import React, {
  useReducer,
  useContext,
  useEffect,
  useState,
  useLayoutEffect,
} from "react";
import { langInitialState, langReducer } from "./lang/lang.reducer";
import {
  WarehousetInitialState,
  WarehouseReducer,
} from "./warehouse/warehouse.reducer";
import { ConfigProvider } from "antd";
import { IntlProvider } from "react-intl";
import Farsi from "../lang/fa-IR.json";
import English from "../lang/en-US.json";
import fa_IR from "antd/lib/locale/fa_IR"; // en_US  fa_IR
import en_US from "antd/lib/locale/fa_IR"; // en_US  fa_IR

const GlobalStateContext: any = React.createContext(null);

const GlobalDispathcerContext: any = React.createContext(null);

export function useGlobalState() {
  const context = useContext(GlobalStateContext);
  if (!context) {
    throw Error("useGlobalState must be used with  a AuthProvider");
  }
  return context;
}

export function useGlobalDispatch() {
  const context = useContext(GlobalDispathcerContext);

  if (!context) {
    throw Error("useGlobalDispatch must be used with  a AuthProvider");
  }

  return context;
}

export function GlobalProvider({ children }: any) {
  const [langState, langDispatch] = useReducer(langReducer, langInitialState);
  const [warehouserList, warehouserListDispatch] = useReducer(
    WarehouseReducer,
    WarehousetInitialState
  );
  const [messages, setMessages] = useState(English);
  const [direction, setDirection] = useState<any>("ltr");
  const [locale, setLocale] = useState(en_US);

  useLayoutEffect(() => {
    const lang = localStorage.getItem("lang")
      ? localStorage.getItem("lang")
      : langState.locale;
    if (lang) {
      if (lang === "en-US") {
        setMessages(English);
        setDirection("ltr");
        setLocale(en_US);
      } else {
        setMessages(Farsi);
        setDirection("rtl");
        setLocale(fa_IR);
      }
    }
  }, [langState]);

  return (
    <GlobalStateContext.Provider value={{ langState, warehouserList }}>
      <GlobalDispathcerContext.Provider
        value={{ langDispatch, warehouserListDispatch }}
      >
        <IntlProvider messages={messages} locale={langState.locale}>
          <ConfigProvider direction={direction} locale={locale}>
            {children}
          </ConfigProvider>
        </IntlProvider>
      </GlobalDispathcerContext.Provider>
    </GlobalStateContext.Provider>
  );
}
